import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _regeneratorRuntime from "@babel/runtime/regenerator";
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
import React, { useState } from 'react';
import { Button, Icon, Form } from 'semantic-ui-react';
import AddressValidationModal from '../../modules/fulfillment/components/AddressValidationModal';
import { FULFILLMENT_PROVIDER_MERCHANT, FULFILLMENT_PROVIDER_SHIPPO, FULFILLMENT_TYPE_TO_TEXT } from '../../modules/fulfillment/constants';
import useAddressValidation from '../../modules/fulfillment/hooks/use-address-validation';
import AddressForm from '../AddressForm';
import AddressSearchForm from '../AddressSearchForm';
import { ActionName } from '../RecaptchaProvider/RecaptchaProvider.constants';
import { useRecaptcha } from '../RecaptchaProvider/RecaptchaProvider.hooks';
import './DynamicAddressForm.css';
var defaultProps = {
  merchant: {},
  fulfillmentMethod: {},
  defaultEnterManualAddress: false,
  showCountryInput: true,
  showVerify: true,
  label: 'Address'
};
function DynamicAddressForm(_ref) {
  var merchant = _ref.merchant,
    fulfillmentMethod = _ref.fulfillmentMethod,
    country = _ref.country,
    state = _ref.state,
    city = _ref.city,
    postalCode = _ref.postalCode,
    line1 = _ref.line1,
    line2 = _ref.line2,
    onChange = _ref.onChange,
    defaultEnterManualAddress = _ref.defaultEnterManualAddress,
    showCountryInput = _ref.showCountryInput,
    showVerify = _ref.showVerify,
    label = _ref.label;
  var _useRecaptcha = useRecaptcha(),
    _useRecaptcha2 = _slicedToArray(_useRecaptcha, 1),
    executeRecaptcha = _useRecaptcha2[0];
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    addressIsVerified = _useState2[0],
    setAddressIsVerified = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    validationModalIsOpen = _useState4[0],
    setValidationModalIsOpen = _useState4[1];
  var _useState5 = useState(defaultEnterManualAddress),
    _useState6 = _slicedToArray(_useState5, 2),
    enterManualAddress = _useState6[0],
    setEnterManualAddress = _useState6[1];
  var _useAddressValidation = useAddressValidation(),
    addressSuggestions = _useAddressValidation.addressSuggestions,
    isValidatingAddress = _useAddressValidation.isValidatingAddress,
    validateAddress = _useAddressValidation.validateAddress,
    resetValidation = _useAddressValidation.resetValidation;
  function verifyAddress() {
    return _verifyAddress.apply(this, arguments);
  }
  function _verifyAddress() {
    _verifyAddress = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var addressData, token, _yield$validateAddres, isValid;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            resetValidation();
            addressData = {
              merchant: merchant,
              fulfillmentMethod: fulfillmentMethod,
              country: country,
              state: state,
              city: city,
              postalCode: postalCode,
              line1: line1,
              line2: line2
            };
            _context.next = 4;
            return executeRecaptcha(ActionName.VALIDATE_ADDRESS);
          case 4:
            token = _context.sent;
            _context.next = 7;
            return validateAddress(token, addressData);
          case 7:
            _yield$validateAddres = _context.sent;
            isValid = _yield$validateAddres.isValid;
            if (isValid) {
              setAddressIsVerified(true);
              onChange({
                isVerified: true
              });
            } else {
              setValidationModalIsOpen(true);
            }
          case 10:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return _verifyAddress.apply(this, arguments);
  }
  function onSearchSelect(data) {
    setAddressIsVerified(false);
    onChange(_objectSpread(_objectSpread({}, data), {}, {
      isVerified: false
    }));
    setEnterManualAddress(true);
  }
  function onManualChange(data) {
    setAddressIsVerified(false);
    onChange(_objectSpread(_objectSpread({}, data), {}, {
      isVerified: false
    }));
  }
  function onModalSelect(address) {
    var addressData = {
      line1: address.street_address,
      line2: address.extended_address,
      city: address.locality,
      state: address.administrative_area_level_1,
      postalCode: address.postal_code
    };
    setAddressIsVerified(true);
    onChange(_objectSpread(_objectSpread({}, addressData), {}, {
      isVerified: true
    }));
    setValidationModalIsOpen(false);
  }
  var buttonVerify = /*#__PURE__*/React.createElement(Button, {
    className: "verify-button",
    onClick: function onClick() {
      return verifyAddress();
    }
  }, "Verify");
  if (addressIsVerified) {
    buttonVerify = /*#__PURE__*/React.createElement(Button, {
      className: "verify-button"
    }, "Verified", /*#__PURE__*/React.createElement(Icon, {
      name: "check circle"
    }));
  }
  if (isValidatingAddress) {
    buttonVerify = /*#__PURE__*/React.createElement(Button, {
      className: "verify-button",
      loading: true
    }, "Verifying");
  }
  return /*#__PURE__*/React.createElement("div", {
    className: "dynamic-address-form-container"
  }, enterManualAddress && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(AddressForm, {
    country: country,
    state: state,
    city: city,
    postalCode: postalCode,
    line1: line1,
    line2: line2,
    onChange: onManualChange,
    showCountryInput: showCountryInput
  }), /*#__PURE__*/React.createElement(Form.Group, {
    className: "manual-form-group"
  }, /*#__PURE__*/React.createElement(Form.Button, {
    className: "toggle-button",
    type: "button",
    onClick: function onClick() {
      return setEnterManualAddress(false);
    }
  }, "Search your address"), showVerify && buttonVerify)), !enterManualAddress && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Form.Group, {
    className: "search-form-group"
  }, /*#__PURE__*/React.createElement(AddressSearchForm, {
    onSelect: onSearchSelect,
    label: label,
    required: true
  })), /*#__PURE__*/React.createElement(Form.Button, {
    className: "toggle-button",
    type: "button",
    onClick: function onClick() {
      return setEnterManualAddress(true);
    }
  }, "Enter address manually")), /*#__PURE__*/React.createElement(AddressValidationModal, {
    open: validationModalIsOpen,
    manualAddress: {
      street_address: line1,
      locality: city,
      administrative_area_level_1: state,
      postal_code: postalCode
    },
    suggestedAddresses: addressSuggestions,
    onCancel: function onCancel() {
      return setValidationModalIsOpen(false);
    },
    onSelect: onModalSelect
  }));
}
DynamicAddressForm.defaultProps = defaultProps;
export default DynamicAddressForm;